import { render, staticRenderFns } from "./DarkCharacterCard.vue?vue&type=template&id=95262294&scoped=true&"
import script from "./DarkCharacterCard.vue?vue&type=script&lang=js&"
export * from "./DarkCharacterCard.vue?vue&type=script&lang=js&"
import style0 from "./DarkCharacterCard.vue?vue&type=style&index=0&id=95262294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95262294",
  null
  
)

export default component.exports